import { useTranslation } from 'react-i18next'

import { useProfilePreferenceActions } from '../../../../hooks/profile/useProfilePreferenceActions'
import { LanguageToggle } from '../../../languageToggle/LanguageToggle'
import { ThemeToggle } from '../../../themeToggle/ThemeToggle'

import packageJson from '../../../../../package.json'
import { getCurrentYear } from '../../../../utils/dateUtils'
import { APP_NAME } from '../../../../constants/brand'

const FootBar = () => {
  const { t } = useTranslation('nav')
  const {
    theme,
    language,
    loading,
    changeTheme,
    changeLanguage,
  } = useProfilePreferenceActions()

  return (
    <footer className="ph-foot">
      <span className="foot-app-info foot-app-info-desktop d-none d-sm-inline">
        {t('foot-bar.app-info', {
          year: getCurrentYear(),
          app: APP_NAME,
          version: packageJson.version,
        })}
      </span>
      <span className="foot-app-info foot-app-info-mobile d-sm-none">
        {t('foot-bar.app-info-mobile', {
          year: getCurrentYear(),
          app: APP_NAME,
        })}
      </span>
      <ThemeToggle
        theme={theme}
        onThemeChange={changeTheme}
        disabled={loading}
        labelClassName="d-none d-sm-inline"
        optionLabelClassName="d-none d-sm-inline"
      />
      <LanguageToggle
        language={language}
        onLanguageChange={changeLanguage}
        disabled={loading}
        labelClassName="d-none d-sm-inline"
      />
    </footer>
  )
}

export default FootBar
